import type { Record, Shape } from '@servicenow/sdk-build-core'

/**
 * Computes the data access value from a role configuration record and its M2M mapping descendants.
 */
export const computeDataAccessValue = (dataAccessConfig: Record | undefined, descendantMappings: Record[] = []) => {
    if (!dataAccessConfig) {
        return undefined
    }

    const roleListRaw = dataAccessConfig.get('role_list')?.getValue()
    let roleListSysIds: string[] | undefined
    if (roleListRaw) {
        const sysIds =
            typeof roleListRaw === 'string'
                ? roleListRaw
                      .split(',')
                      .map((r: string) => r.trim())
                      .filter(Boolean)
                : Array.isArray(roleListRaw)
                  ? (roleListRaw as string[])
                  : [roleListRaw as string]
        if (sysIds.length > 0) {
            roleListSysIds = sysIds
        }
    }

    const parentSysId = dataAccessConfig.getId().getValue()
    const mappingRows = descendantMappings.filter((row) => {
        const fkValue = row.get('agent_access_config')?.toString().getValue()
        return typeof fkValue === 'string' && fkValue === parentSysId
    })
    const roleShapes: Shape[] = mappingRows
        .map((row) => row.get('role'))
        .filter((shape): shape is Shape => shape !== undefined)

    return dataAccessConfig.transform(({ $ }) => ({
        description: $.from('description').def(''),
        ...(roleListSysIds && roleListSysIds.length > 0 ? { roleList: $.val(roleListSysIds) } : {}),
        ...(roleShapes.length > 0 ? { roleMap: $.val(roleShapes) } : {}),
    }))
}
